export default "__VITE_ASSET__CMyAuH0R__"